export default class DataColumnCollection {
    constructor(columns = [], isLocked = false) {
        this.isLocked = isLocked;
        this.columns = columns;
    }
    get columns() {
        return this._columns;
    }
    set columns(columns) {
        columns.forEach(column => {
            if (this.isLocked) {
                column.isLocked = true;
            }
        });
        this._columns = columns;
    }
}
